export enum CoverageGroupIdEnum {
    Liability = 'AVP',
    VehicleBase = 'BASE',
    CarRedressLegalAid = 'AVHS',
    RoadsideAssistance = 'PH',
    CarDamageInsuranceOccupants = 'ASVI',
    Moped = 'BROM',
    Caravan = 'CVAN',
    CaravanHouseholdEffects = 'CINB',
    CaravanExtra = 'ACCS',
    CaravanHail = 'HGL',
    PetAccident = 'BZDO',
    PetCare = 'AD',
    PetBase = 'SZGP',
    PetCrem = 'CREM',
    PetExtraCoverage = 'FYSI',
    PetCancerTreatment = 'CHEM',
    PetTeeth = 'TAND',
    MotorRedressLegalAid = 'MVHS',
    MotorDamageInsuranceOpputants = 'MSVO',
    MotorAccidentPermanentInjury = 'INVL',
    MotorAccidentDeath = 'OVRL',
    LegalConsumerAndHome = 'CENW',
    LegalWorkAndIncome = 'WENI',
    LegalFamilyAndWealth = 'FENV',
    LegalWorldwide = 'ORB',
    TravelEurope = 'EURB',
    TravelWorld = 'WERB',
    TravelVehicleAssistance = 'VHLP',
    TravelCancellation = 'ANNU',
    TravelMedicalCost = 'GEN',
    HomeHouseholdEffectStandard = 'INBL',
    HomeBuildingStandard = 'OPST',
    HomeOwnerTenantInterest = 'HUAP',
    HomeGlass = 'GLAS',
    HomeMobileElectronics = 'MBEL',
    HomeComplete = 'WOAR',
    BicycleHomeDeliveryService = 'FTBP',
}
